import {
  SEARCH_QUERY,
  SEARCH_RESET,
  SEARCH_LOAD_COMPLETE,
  SEARCH_CATEGORY,
  SEARCH_CATEGORY_COMPLETE,
  SEARCH_CHANGE_PAGE
} from '../constants/actionTypes';

export const initialState = {
  query: '',
  page: 1,
  size: 5,
  total: 0,
  totalContents: 0,
  totalDocuments: 0,
  totalFolders: 0,
  totalUsers: 0,
  totalAssociations: 0,
  totalAll: 0,
  items: [],
  category: 'all'
};
// alternative is to use defaultTo instead of propOr
// const createReducer = (init, handlers) => (state = init, action) =>
//   propOr(identity, prop('type', action), handlers)(state, action);

export default (state = initialState, action) => {
  const {
    type,
    query,
    items,
    total,
    totalAll,
    totalContents,
    totalDocuments,
    totalFolders,
    totalUsers,
    totalAssociations,
    category,
    page
  } = action;

  switch (type) {
    case SEARCH_QUERY:
      return { ...state, query };

    case SEARCH_RESET:
      return { ...state, ...initialState };

    case SEARCH_LOAD_COMPLETE:
      return {
        ...state,
        items,
        total,
        totalAll,
        totalContents,
        totalDocuments,
        totalFolders,
        totalUsers,
        totalAssociations
      };

    case SEARCH_CATEGORY:
      return {
        ...state,
        page: 1,
        category
      };

    case SEARCH_CATEGORY_COMPLETE:
      return {
        ...state,
        items,
        total,
        totalAll,
        totalContents,
        totalDocuments,
        totalFolders,
        totalUsers,
        totalAssociations
      };

    case SEARCH_CHANGE_PAGE:
      return {
        ...state,
        page
      };

    default:
      return state;
  }
};
